import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import Loader from '../Loader/Loader.js';

const renderButtonContent = (icon = '', caption)=>/*#__PURE__*/ React.createElement(React.Fragment, null, icon && /*#__PURE__*/ React.createElement("span", {
        className: "button__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon
    })), /*#__PURE__*/ React.createElement("span", {
        className: "button__text"
    }, caption), /*#__PURE__*/ React.createElement("div", {
        className: "button__loader-wrapper"
    }, /*#__PURE__*/ React.createElement(Loader, {
        className: "button__loader"
    })))
;
const Button = (_param)=>{
    var { caption , type ='button' , variant ='solid' , size ='medium' , color ='primary' , buttonId , disabled , isLoading , icon , btnRef , href , hrefTarget , className , form , onClick , tabIndex  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "caption",
        "type",
        "variant",
        "size",
        "color",
        "buttonId",
        "disabled",
        "isLoading",
        "icon",
        "btnRef",
        "href",
        "hrefTarget",
        "className",
        "form",
        "onClick",
        "tabIndex"
    ]);
    const classes = classnames(`button button--${variant} button--${size}`, {
        [`button--color-${color}`]: variant !== 'barebones'
    }, className, {
        _is_disabled: disabled,
        _is_loading: isLoading
    });
    if (href) {
        return disabled ? /*#__PURE__*/ React.createElement("div", {
            className: classes,
            "data-t": rest['data-t'],
            style: rest.style
        }, renderButtonContent(icon, caption)) : /*#__PURE__*/ React.createElement("a", {
            className: classes,
            href: href,
            target: hrefTarget,
            rel: hrefTarget === '_blank' ? 'noreferrer noopener' : undefined,
            "aria-busy": isLoading,
            "data-t": rest['data-t'],
            "aria-label": rest['aria-label'],
            "aria-describedby": rest['aria-describedby'],
            "data-element-id": rest['data-element-id'],
            "data-description": rest['data-description'],
            onClick: onClick,
            tabIndex: tabIndex,
            style: rest.style
        }, renderButtonContent(icon, caption));
    }
    return(// eslint-disable-next-line jsx-a11y/role-supports-aria-props
    /*#__PURE__*/ React.createElement("button", {
        type: type,
        id: buttonId,
        className: classes,
        onClick: !disabled && onClick || undefined,
        disabled: isLoading || disabled || false,
        // the select service store button is used like a form element
        "aria-invalid": rest['aria-invalid'],
        "aria-label": rest['aria-label'],
        "aria-describedby": rest['aria-describedby'],
        "aria-pressed": rest['aria-pressed'],
        "aria-busy": isLoading,
        "data-t": rest['data-t'],
        "data-element-id": rest['data-element-id'],
        "data-description": rest['data-description'],
        form: form,
        ref: btnRef,
        tabIndex: tabIndex,
        style: rest.style
    }, renderButtonContent(icon, caption)));
};

export { Button as default };
//# sourceMappingURL=Button.js.map
